if ($(window).width() >= 1200) {
  let engine = null;
  let world = null;
  let render = null;
  let runner = null;
  let mouseConstraint = null;
  let outOfBoundsCount = 0;
  let hasInitialized = false; // So we only trigger once

  function initMatter(matterHolder) {
    // Clear existing Matter.js engine if it exists
    if (engine) {
      Matter.World.clear(world);
      Matter.Engine.clear(engine);
      if (runner) Matter.Runner.stop(runner);
      if (render) Matter.Render.stop(render);

      const oldCanvas = matterHolder.querySelector("canvas");
      if (oldCanvas) oldCanvas.remove();
    }

    // Matter.js aliases
    const Engine = Matter.Engine,
      Render = Matter.Render,
      Runner = Matter.Runner,
      Bodies = Matter.Bodies,
      World = Matter.World,
      Mouse = Matter.Mouse,
      MouseConstraint = Matter.MouseConstraint,
      Composite = Matter.Composite,
      Events = Matter.Events;

    // Create a new engine and world
    engine = Engine.create();
    world = engine.world;
    engine.enableSleeping = true;

    const width = matterHolder.clientWidth;
    const height = matterHolder.clientHeight;
    const scale = window.devicePixelRatio;

    // Create a renderer
    render = Render.create({
      element: matterHolder,
      engine,
      options: {
        wireframes: true,
        background: "transparent",
        width,
        height,
      },
    });
    Matter.Render.setPixelRatio(render, scale);

    // Create and run the runner
    runner = Runner.create();
    Runner.run(runner, engine);

    // Set gravity
    engine.world.gravity.y = 0.2;

    // Create boundary walls
    World.add(world, [
      Bodies.rectangle(width / 2, height + 250, width, 500, {
        isStatic: true,
        label: "_noMap",
      }),
      Bodies.rectangle(width / 2, -50, width, 100, {
        isStatic: true,
        label: "_noMap",
      }),
      Bodies.rectangle(-50, height / 2, 100, height, {
        isStatic: true,
        label: "_noMap",
      }),
      Bodies.rectangle(width + 50, height / 2, 100, height, {
        isStatic: true,
        label: "_noMap",
      }),
    ]);

    // Placement and spacing for objects
    const placement = { x: 1, y: 1 };
    const spacing = { x: 300, y: 300 };
    const offsetY = 300;
    // (Optional) Reveal hidden objects before we add them
    matterHolder.querySelectorAll("[data-object]").forEach((el) => {
      el.classList.remove("hidden-object");
    });

    // Add all [data-object] elements as Matter.js bodies
    matterHolder.querySelectorAll("[data-object]").forEach((object) => {
      addObject(object);
    });

    function addObject(object) {
      const objWidth = object.scrollWidth;
      const objHeight = object.scrollHeight;
      const rect = Bodies.rectangle(
        placement.x * spacing.y,
        (placement.y * spacing.x) - offsetY,
        objWidth,
        objHeight,
        {
          label: object.getAttribute("data-object"),
          density: 0.8,
          frictionAir: 0.005,
          restitution: 0.5,
          friction: 0.001,
          render: { fillStyle: "transparent" },
        }
      );
      World.add(world, rect);

      // Slight random rotation
      const rotation = (Math.random() < 0.5 ? -1 : 1) * (Math.random() * 1);
      Matter.Body.rotate(rect, rotation);

      checkPlacement();
    }

    function checkPlacement() {
      placement.x++;
      if (placement.x * spacing.x > width - spacing.x) {
        placement.y++;
        placement.x = 1;
      }
    }

    // Mouse control
    const mouse = Mouse.create(render.canvas);
    mouseConstraint = MouseConstraint.create(engine, {
      mouse,
      constraint: { stiffness: 0.2, render: { visible: false } },
    });
    World.add(world, mouseConstraint);
    render.mouse = mouse;

    // ======== SCROLL FIX: Only block scroll if user is dragging a body ========
    render.canvas.style.touchAction = "pan-y pinch-zoom";

    render.canvas.addEventListener(
      "pointermove",
      (e) => {
        if (mouseConstraint.body) {
          e.preventDefault(); // Block scroll during drag
        }
      },
      { passive: false }
    );

    render.canvas.addEventListener(
      "touchmove",
      (e) => {
        if (mouseConstraint.body) {
          e.preventDefault(); // Block scroll during drag
        }
      },
      { passive: false }
    );

    render.canvas.addEventListener(
      "wheel",
      (e) => {
        if (mouseConstraint.body) {
          e.preventDefault(); // Block scroll during drag
        }
      },
      { passive: false }
    );

    // Start the renderer
    Render.run(render);

    // Animate HTML elements to match physics
    window.requestAnimationFrame(mapHTML);

    function mapHTML() {
      const allBodies = Composite.allBodies(world);
      allBodies.forEach((body) => {
        if (body.label === "_noMap") return;

        const targetObject = matterHolder.querySelector(
          `[data-object="${body.label}"]`
        );
        if (!targetObject) return;

        targetObject.style.setProperty("--move-x", `${body.position.x}px`);
        targetObject.style.setProperty("--move-y", `${body.position.y}px`);
        targetObject.style.setProperty("--rotate", `${body.angle}rad`);
      });
      window.requestAnimationFrame(mapHTML);
    }

    // Check for objects going out of bounds
    Events.on(engine, "afterUpdate", checkOutOfBounds);
    function checkOutOfBounds() {
      outOfBoundsCount = 0;
      const allBodies = Composite.allBodies(world);

      allBodies.forEach((body) => {
        if (body.label === "_noMap") return; // ignore boundary boxes
        const isOOB =
          body.position.x < 0 ||
          body.position.x > width ||
          body.position.y < 0 ||
          body.position.y > height;
        if (isOOB) outOfBoundsCount++;
      });

      const resetButton = document.getElementById("resetButton");
      if (resetButton) {
        resetButton.style.display = outOfBoundsCount > 0 ? "block" : "none";
      }
    }
  }

  // =========================================
  // Only init Matter.js once 50% is visible
  // =========================================
  document.addEventListener("DOMContentLoaded", () => {
    const matterHolder = document.querySelector("[data-html-matter]");
    if (!matterHolder) return;

    const resetButton = document.getElementById("resetButton");
    if (resetButton) {
      // Hide the reset button initially
      resetButton.style.display = "none";

      // If someone clicks it manually later, it re-inits
      resetButton.addEventListener("click", () => {
        initMatter(matterHolder);
      });
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasInitialized) {
            hasInitialized = true;

            // Show the reset button (optional)
            if (resetButton) resetButton.style.display = "block";

            // Trigger the physics initialization
            initMatter(matterHolder);

            // Stop observing after the first time
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 } // 30% visible
    );

    observer.observe(matterHolder);
  });
}
